import { Component, Input } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-file-preview-btn',
  templateUrl: './file-preview-btn.component.html',
  styleUrls: ['./file-preview-btn.component.scss'],
})
export class FilePreviewBtnComponent {
  @Input() file_path?: string;

  getFileIcon() {
    let icon = 'bi-earmark fw-semibold';
    if (this.file_path?.endsWith('.aac')) {
      icon = 'bi-filetype-aac fw-semibold';
    }
    if (this.file_path?.endsWith('.ai')) {
      icon = 'bi-filetype-ai fw-semibold';
    }
    if (this.file_path?.endsWith('.bmp')) {
      icon = 'bi-filetype-bmp fw-semibold';
    }
    if (this.file_path?.endsWith('.cs')) {
      icon = 'bi-filetype-cs fw-semibold';
    }
    if (this.file_path?.endsWith('.css')) {
      icon = 'bi-filetype-css fw-semibold';
    }
    if (this.file_path?.endsWith('.csv')) {
      icon = 'bi-filetype-csv fw-semibold';
    }
    if (this.file_path?.endsWith('.doc')) {
      icon = 'bi-filetype-doc fw-semibold';
    }
    if (this.file_path?.endsWith('.docx')) {
      icon = 'bi-filetype-docx fw-semibold';
    }
    if (this.file_path?.endsWith('.exe')) {
      icon = 'bi-filetype-exe fw-semibold';
    }
    if (this.file_path?.endsWith('.gif')) {
      icon = 'bi-filetype-gif fw-semibold';
    }
    if (this.file_path?.endsWith('.heic')) {
      icon = 'bi-filetype-heic fw-semibold';
    }
    if (this.file_path?.endsWith('.html')) {
      icon = 'bi-filetype-html fw-semibold';
    }
    if (this.file_path?.endsWith('.java')) {
      icon = 'bi-filetype-java fw-semibold';
    }
    if (this.file_path?.endsWith('.jpg')) {
      icon = 'bi-filetype-jpg fw-semibold';
    }
    if (this.file_path?.endsWith('.js')) {
      icon = 'bi-filetype-js fw-semibold';
    }
    if (this.file_path?.endsWith('.json')) {
      icon = 'bi-filetype-json fw-semibold';
    }
    if (this.file_path?.endsWith('.jsx')) {
      icon = 'bi-filetype-jsx fw-semibold';
    }
    if (this.file_path?.endsWith('.key')) {
      icon = 'bi-filetype-key fw-semibold';
    }
    if (this.file_path?.endsWith('.m4p')) {
      icon = 'bi-filetype-m4p fw-semibold';
    }
    if (this.file_path?.endsWith('.md')) {
      icon = 'bi-filetype-md fw-semibold';
    }
    if (this.file_path?.endsWith('.mdx')) {
      icon = 'bi-filetype-mdx fw-semibold';
    }
    if (this.file_path?.endsWith('.mov')) {
      icon = 'bi-filetype-mov fw-semibold';
    }
    if (this.file_path?.endsWith('.mp3')) {
      icon = 'bi-filetype-mp3 fw-semibold';
    }
    if (this.file_path?.endsWith('.mp4')) {
      icon = 'bi-filetype-mp4 fw-semibold';
    }
    if (this.file_path?.endsWith('.otf')) {
      icon = 'bi-filetype-otf fw-semibold';
    }
    if (this.file_path?.endsWith('.pdf')) {
      icon = 'bi-filetype-pdf fw-semibold';
    }
    if (this.file_path?.endsWith('.php')) {
      icon = 'bi-filetype-php fw-semibold';
    }
    if (this.file_path?.endsWith('.png')) {
      icon = 'bi-filetype-png fw-semibold';
    }
    if (this.file_path?.endsWith('.ppt')) {
      icon = 'bi-filetype-ppt fw-semibold';
    }
    if (this.file_path?.endsWith('.pptx')) {
      icon = 'bi-filetype-pptx fw-semibold';
    }
    if (this.file_path?.endsWith('.psd')) {
      icon = 'bi-filetype-psd fw-semibold';
    }
    if (this.file_path?.endsWith('.py')) {
      icon = 'bi-filetype-py fw-semibold';
    }
    if (this.file_path?.endsWith('.raw')) {
      icon = 'bi-filetype-raw fw-semibold';
    }
    if (this.file_path?.endsWith('.rb')) {
      icon = 'bi-filetype-rb fw-semibold';
    }
    if (this.file_path?.endsWith('.sass')) {
      icon = 'bi-filetype-sass fw-semibold';
    }
    if (this.file_path?.endsWith('.scss')) {
      icon = 'bi-filetype-scss fw-semibold';
    }
    if (this.file_path?.endsWith('.sh')) {
      icon = 'bi-filetype-sh fw-semibold';
    }
    if (this.file_path?.endsWith('.sql')) {
      icon = 'bi-filetype-sql fw-semibold';
    }
    if (this.file_path?.endsWith('.svg')) {
      icon = 'bi-filetype-svg fw-semibold';
    }
    if (this.file_path?.endsWith('.tiff')) {
      icon = 'bi-filetype-tiff fw-semibold';
    }
    if (this.file_path?.endsWith('.tsx')) {
      icon = 'bi-filetype-tsx fw-semibold';
    }
    if (this.file_path?.endsWith('.ttf')) {
      icon = 'bi-filetype-ttf fw-semibold';
    }
    if (this.file_path?.endsWith('.txt')) {
      icon = 'bi-filetype-txt fw-semibold';
    }
    if (this.file_path?.endsWith('.wav')) {
      icon = 'bi-filetype-wav fw-semibold';
    }
    if (this.file_path?.endsWith('.woff')) {
      icon = 'bi-filetype-woff fw-semibold';
    }
    if (this.file_path?.endsWith('.xls')) {
      icon = 'bi-filetype-xls fw-semibold';
    }
    if (this.file_path?.endsWith('.xlsx')) {
      icon = 'bi-filetype-xlsx fw-semibold';
    }
    if (this.file_path?.endsWith('.xml')) {
      icon = 'bi-filetype-xml fw-semibold';
    }
    if (this.file_path?.endsWith('.yml')) {
      icon = 'bi-filetype-yml fw-semibold';
    }
    return icon;
  }
}
